import { createTheme } from '@mui/material/styles';
import { COLORS } from '../constants/system/colors';

const MainTheme: MainTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: COLORS.primaryMain,
      light: COLORS.primaryLight,
      dark: COLORS.primaryDark,
      contrastText: COLORS.infoLight,
    },
    secondary: {
      main: COLORS.secondaryMain,
      light: COLORS.secondaryLight,
      dark: COLORS.secondaryDark,
    },
    action: {
      disabled: COLORS.actionDisabled,
    },
    background: {
      default: COLORS.backgroundDefault,
      paper: COLORS.backgroundPaper,
    },
    info: {
      main: COLORS.infoMain,
      light: COLORS.infoLight,
    },
    text: {
      primary: COLORS.black,
    },
    error: {
      main: COLORS.errorMain,
      light: COLORS.errorLight,
    },
    success: {
      main: COLORS.successMain,
      light: COLORS.successLight,
    },
    warning: {
      main: COLORS.warningMain,
      light: COLORS.backgroundWarning,
    },
    common: {
      black: COLORS.black,
      white: COLORS.white,
    },
  },
  typography: {
    body1: {
      fontSize: 14,
    },
    button: {
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 0,
  },
  components: {
    MuiCheckbox: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiLink: {
      defaultProps: {
        color: 'secondary',
        underline: 'hover',
      },
    },
    MuiMenu: {
      defaultProps: {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'unset',
        },
      },
    },
    MuiAvatar: {
      defaultProps: {
        variant: 'square',
      },
    },
    MuiChip: {
      styleOverrides: {
        avatarColorPrimary: {
          backgroundColor: COLORS.white,
        },
        label: {
          color: COLORS.black,
        },
      },
    },
    MuiIcon: {
      defaultProps: {
        fontSize: 'inherit',
      },
    },
    MuiIconButton: {
      defaultProps: {
        size: 'large',
      },
      styleOverrides: {
        colorSecondary: {
          '&:hover': {
            backgroundColor: COLORS.backgroundDark,
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiButton: {
      styleOverrides: {
        textPrimary: {
          color: COLORS.black,
        },
      },
    },
  },
});

export default MainTheme;
